import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const UserWorkExperience = () => {
  const [companyName, setCompanyName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [experience, setExperience] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await AxiosInstance.get("companies/roles/");
        if (response.status === 200) {
          setRoleOptions(response.data);
        } else {
          setErrorMessage("Failed to load roles.");
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
        setErrorMessage("Failed to load roles.");
      }
    };

    fetchRoles();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!userId) {
      setErrorMessage("User not logged in. Please login first.");
      setIsLoading(false);
      return;
    }
    if (!companyName || !selectedRole || !experience) {
      setErrorMessage("Please fill all required fields.");
      setIsLoading(false);
      return;
    }

    const newWorkExperience = {
      user: userId,
      company_name: companyName,
      role: selectedRole,
      experience,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/work-experiences/",
        newWorkExperience
      );

      if (response.status === 201) {
        alert("Work experience added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Failed to save work experience.");
      }
    } catch (error) {
      console.error("Error saving work experience:", error);
      setErrorMessage("Error saving work experience. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Add Work Experience</h5>
            </div>

            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    className="form-control"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="selectedRole" className="form-label">
                    Role <span className="text-danger">*</span>
                  </label>
                  <select
                    id="selectedRole"
                    className="form-select"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    required
                    disabled={isLoading}
                  >
                    <option value="">Select Role</option>
                    {roleOptions.length > 0 ? (
                      roleOptions.map((role) => (
                        <option key={role.role_id} value={role.role_id}>
                          {role.role}
                        </option>
                      ))
                    ) : (
                      <option value="">No roles available</option>
                    )}
                  </select>
                </div>

                <div className="mb-3">
                  <label htmlFor="experience" className="form-label">
                    Experience <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="experience"
                    className="form-control"
                    value={experience}
                    onChange={(e) => setExperience(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isLoading}>
                    {isLoading ? "Saving..." : "Save Work Experience"}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UserWorkExperience;
